import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as personnelLeaders from '../../personnel-leaders'

export const RESOURCE = {
  payload: {
    description:
      'A relationship between some member of personnel and a leader of some kind (e.g. manager or mentor).',
    dimension: personnelLeaders.RESOURCE.payload,
    level: 0,
    name: 'Relationship',
    partialId: PartialId.Standard.create('relationship'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
